<template>
  <TablePosition />
</template>
<script>
import TablePosition from "./components/tablePosition";
export default {
  components: {
    TablePosition,
  },
  methods: {},
  created() {},
};
</script>
<style></style>
